import { render, staticRenderFns } from "./ResponsiveIframeYoutube.vue?vue&type=template&id=56ddc34e&scoped=true&"
import script from "./ResponsiveIframeYoutube.vue?vue&type=script&lang=js&"
export * from "./ResponsiveIframeYoutube.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveIframeYoutube.vue?vue&type=style&index=0&id=56ddc34e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ddc34e",
  null
  
)

export default component.exports